"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdtfPartialBuffer = void 0;
const SdtfBasePartialComponent_1 = require("./SdtfBasePartialComponent");
class SdtfPartialBuffer extends SdtfBasePartialComponent_1.SdtfBasePartialComponent {
    constructor() {
        super(...arguments);
        this.additionalProperties = {};
    }
    toJson() {
        const json = Object.assign({}, this.additionalProperties);
        if (this.byteLength !== undefined)
            json.byteLength = this.byteLength;
        else
            delete json.byteLength;
        if (this.uri !== undefined)
            json.uri = this.uri;
        delete json.uri;
        return json;
    }
}
exports.SdtfPartialBuffer = SdtfPartialBuffer;
//# sourceMappingURL=SdtfPartialBuffer.js.map